import { Box, Button, Link, Stack, Typography } from '@mui/material'
import React from 'react'

export default function NotFoundPage() {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: "center", alignItems: 'center', height: '100vh' }}>
            <Stack spacing={2} alignItems='center' sx={{ mt: 2 }}>
                <Typography color='primary' variant='h4'>What on earth are you doing here!</Typography>
                <Typography variant='subtitle2'>Well, this is awkward, the page you were trying to view does not exist.</Typography>
                <Link href="/"><Button variant='contained'>Back to home</Button></Link>
            </Stack>
        </Box>
    )
}
